import ChevDown from "@/seed/components/elements/chev-down";
import RoundInfo from "@/seed/components/elements/round-info";
import TokenSaleHero from "@/seed/components/modules/token-sale/token-sale-hero";
import PoolContext from "@/seed/contexts/pool/pool-context";
import { useContext } from "react";

const UpComing = () => {
    const { layoutContentDef, saleEvent } = useContext(PoolContext);
    if (!layoutContentDef || !saleEvent) return <div>Loading</div>;
    console.log("UpComing", { layoutContentDef, saleEvent });
    return (
        <>
            <div className="absolute">
                <section id="hero" className="bg-[url('/img/hero.png')] bg-center bg-cover">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
                <section id="user-guide" className="">
                    <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
                </section>
            </div>

            <div className="absolute w-screen top-[20%] landscape:top-[30%]">
                <div className="container mx-auto flex flex-col items-center justify-center w-full px-[2%]">
                    <TokenSaleHero
                        data={{
                            ...layoutContentDef.tokenSaleHero,
                            countdown: {
                                ...layoutContentDef.tokenSaleHero.countdown,
                                ...saleEvent.countdown,
                            },
                            saleInfo: saleEvent,
                        }}
                    />
                    <ChevDown />
                    <RoundInfo data={saleEvent.roundOverview} />
                </div>
            </div>
        </>
    );
};

export default UpComing;
